export default "__VITE_ASSET__14fd672d__"